import React from 'react';
import '../../index.css';
import StarRating from '../ui/StarRating';

// Testimonial card component
const TestimonialCard = ({ testimonial }) => {
  return (
    <div className="flex flex-col ">
      <div className="flex items-center mb-[16px]">
        <img 
          src={testimonial.image} 
          alt={`Portrait of ${testimonial.name}`} 
          className="w-14 h-14 rounded-full mr-4 object-cover border-2 border-gray-100"
        />
        <div>
          <h3 className="font-[LTWave] font-medium text-xl">{testimonial.name}</h3>
          <p className="text-gray-500 text-sm">{testimonial.date}</p>
        </div>
      </div>
      <StarRating rating={testimonial.rating} />
      <p className="mt-[16px] text-gray-700 text-[16px] leading-[1.6]">"{testimonial.quote}"</p>
    </div>
  );
};

const TestimonialsSection = () => {
  // Testimonials data
  const testimonials = [
    {
      id: 1,
      name: 'Ravi',
      date: 'June 15, 2023',
      rating: 5,
      image: 'https://randomuser.me/api/portraits/men/32.jpg',
      quote: 'Agastya Products has been a game-changer for my farm. Their products are top-notch, and their customer service is exceptional. I highly recommend them!'
    },
    {
      id: 2,
      name: 'Suresh Patel',
      date: 'May 22, 2023',
      rating: 4,
      image: 'https://randomuser.me/api/portraits/men/41.jpg',
      quote: 'I\'ve been using Agastya Products for years, and they consistently deliver high-quality products. Their team is knowledgeable and always ready to help.'
    },
    {
      id: 3,
      name: 'Raveena',
      date: 'April 10, 2023',
      rating: 5,
      image: 'https://randomuser.me/api/portraits/women/44.jpg',
      quote: 'I\'m impressed with Agastya\'s commitment to sustainability. Their eco-friendly products have helped me reduce my environmental impact without compromising on yield.'
    },
    {
      id: 4,
      name: 'Kamla',
      date: 'April 10, 2023',
      rating: 5,
      image: 'https://randomuser.me/api/portraits/women/68.jpg',
      quote: 'I\'m impressed with Agastya\'s commitment to sustainability. Their eco-friendly products have helped me reduce my environmental impact without compromising on yield.'
    }
  ];

  return (
    <section className="py-[42px] md:py-12 lg:py-[80px] bg-[#F9F9FB]">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <h2 className="font-[LTWave] text-center testimonial-heading text-[28px] md:text-[44px] leading-[150%] mb-[39px]">
          Customer Testimonials
        </h2>
        
        <div className="grid grid-cols-1 md:grid-rows-4 gap-[40px] max-w-[1288px] mx-auto" >
          {testimonials.map(testimonial => (
            <TestimonialCard key={testimonial.id} testimonial={testimonial} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
